// Single source of truth for the displayed application version.
// Shown on the login screen, in the sidebar and in Settings → What's New.
//
// ┌─────────────────────────────────────────────────────────────────────────┐
// │ VERSION BUMP CHECKLIST — do ALL 4 before you Deploy (Emergent ships the   │
// │ repo but does NOT auto-bump the version). Convention: PATCH = fixes,      │
// │ MINOR = new features, MAJOR = big/breaking shifts.                        │
// │   [1] Bump APP_VERSION below.                                             │
// │   [2] Add a matching entry to the TOP of                                  │
// │       /app/frontend/public/release-notes.json (plain English, newest      │
// │       first) so Settings → What's New shows it. Shape:                    │
// │         { "version": "1.2.3", "date": "18 Aug 2026", "title": "…",        │
// │           "highlights": ["…", "…"] }                                      │
// │   [3] Prepend the SAME version to /app/memory/CHANGELOG.md (this is what  │
// │       "View full changelog" serves via the backend). Skip it → the full   │
// │       changelog silently goes stale.                                      │
// │   [4] Update /app/frontend/public/version.json to the SAME version — the  │
// │       VersionChecker compares it to APP_VERSION to prompt a refresh after │
// │       a deploy. If it drifts, users get a spurious "update available".    │
// │ All 4 must match. (Drift here caused the 1.76.0-vs-1.84.0 gap fixed in    │
// │ v1.85.0.) The gate's "Version bump owed" step fails if Production's live  │
// │ version.json already says APP_VERSION and app code has changed since.     │
// └─────────────────────────────────────────────────────────────────────────┘
export const APP_VERSION = '1.416.0';

// The release notes used to live in this file as a 3,800-line array, which meant
// every visitor downloaded ~280KB of three years' history to render a version
// number in the sidebar. They now sit in /public/release-notes.json and are
// fetched only when someone opens What's New (hardening P3, 18 Aug 2026).
const NOTES_URL = `${process.env.PUBLIC_URL || ''}/release-notes.json`;

let cache = null;
let inFlight = null;

/** The curated, plain-English release notes, newest first. Fetched once per session. */
export async function loadReleaseNotes() {
  if (cache) return cache;
  if (inFlight) return inFlight;
  inFlight = (async () => {
    try {
      const response = await fetch(NOTES_URL, { headers: { Accept: 'application/json' } });
      if (!response.ok) {
        throw new Error(`Release notes unavailable (${response.status})`);
      }
      const data = await response.json();
      cache = Array.isArray(data?.releases) ? data.releases : [];
      return cache;
    } finally {
      inFlight = null;
    }
  })();
  return inFlight;
}
